import React from 'react';
import { bool, arrayOf } from 'prop-types';
import cx from 'classnames';

import coord from 'propTypes/coord';

import styles from './ExistingSegmentPath.scss';

export default function ExistingSegmentPath({ latLngList, isActive }) {
  // eslint-disable-next-line global-require
  const { Polyline } = require('react-leaflet');

  return (
    <div>
      <Polyline
        className={cx(styles.outline, {
          [styles.isActive]: isActive,
        })}
        positions={latLngList}
      />
      {isActive && <Polyline positions={latLngList} className={styles.underline} />}
      <Polyline
        positions={latLngList}
        className={cx(styles.line, {
          [styles.isActive]: isActive,
        })}
      />
    </div>
  );
}

ExistingSegmentPath.propTypes = {
  latLngList: arrayOf(coord).isRequired,
  isActive: bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/CreateSegment/ExistingSegmentPath/index.js